import { EntityId } from '@reduxjs/toolkit';
import {
  CampaignTemplateItemDTO,
  CommunicationCampaignTemplateInDAO,
  CommunicationCampaignTemplateOutDAO,
} from '../template.type';
import { notifApi } from './campaign.api';

export const createCommunicationCampaignTemplateApi = async (request: CommunicationCampaignTemplateOutDAO) => {
  const response = await notifApi.api.post<CommunicationCampaignTemplateOutDAO>(`api/v2/campaign-templates`, request);
  return response.data;
};

export const createCommunicationCampaignTemplateFromCampaignApi = async (
  campaignId: EntityId,
  name: string,
): Promise<CommunicationCampaignTemplateOutDAO> => {
  const response = await notifApi.api.post<CommunicationCampaignTemplateOutDAO>(
    `api/v2/campaign-templates/convert/${campaignId}`,
    { name },
  );
  return response.data;
};

export const getCampaignTemplateListApi = async () => {
  const response = await notifApi.api.get<CampaignTemplateItemDTO[]>('api/v2/campaign-templates/list');
  return response.data;
};

export const getCampaignTemplateByIdApi = async (templateId: EntityId) => {
  const response = await notifApi.api.get<CommunicationCampaignTemplateInDAO>(
    `api/v2/campaign-templates/${templateId}`,
  );
  return response.data;
};

export const deleteCampaignTemplateApi = async (templateId: EntityId) => {
  const response = await notifApi.api.delete(`api/v2/campaign-templates/${templateId}`);
  return response.data;
};
